import React from "react";
import { render } from 'react-dom'
import { createStore } from 'redux'
import { Provider } from 'react-redux'
import  mainReducer  from './reducers/index'
import ForgetPasswordSendEmailAppComponent from './components/ForgetPasswordSendEmailAppComponent';
import "../../i18n";

const store = createStore(mainReducer);
render(
    <div>
        <Provider store={store}>
            <ForgetPasswordSendEmailAppComponent cmeUno={CmeUno} />
        </Provider>
    </div>
    , document.getElementById("forgetpasswordsendemail")
);


